import { defineStore } from 'pinia';
import { twinfieldService } from '@/services/twinfieldService';

/**
 * Twinfield connection for the integrations settings screen.
 * Invoice sync itself runs on the API; this store only drives OAuth.
 */
export const useTwinfieldStore = defineStore('twinfield', {
  state: () => ({
    status: null,
    statusLoading: false,
    error: null,
  }),

  actions: {
    async fetchStatus() {
      this.statusLoading = true;
      this.error = null;
      try {
        const data = await twinfieldService.getStatus();
        this.status = data;
        return data;
      } catch (error) {
        this.error = error?.response?.data?.error || error.message;
        throw error;
      } finally {
        this.statusLoading = false;
      }
    },

    /**
     * Open the Twinfield consent screen. Resolves when the callback
     * posts `{ type: 'twinfield:oauth' }` back to this window.
     */
    async startOAuth() {
      const { url } = await twinfieldService.getAuthorizeUrl();
      if (!url) throw new Error('No OAuth URL returned');

      const popup = window.open(
        url,
        'twinfield-connect',
        'width=540,height=720,resizable=yes,scrollbars=yes'
      );

      if (!popup) {
        window.location.assign(url);
        return { success: false, error: 'popup_blocked' };
      }

      return new Promise((resolve) => {
        let settled = false;

        const cleanup = () => {
          window.removeEventListener('message', onMessage);
          clearInterval(closedTimer);
        };

        const finish = (payload) => {
          if (settled) return;
          settled = true;
          cleanup();
          try {
            popup.close();
          } catch {
            /* already closed */
          }
          resolve(payload);
        };

        const onMessage = (event) => {
          const data = event?.data;
          if (!data || data.type !== 'twinfield:oauth') return;
          finish({ success: !!data.success, error: data.error });
        };

        window.addEventListener('message', onMessage);

        const closedTimer = setInterval(() => {
          if (popup.closed) finish({ success: false, error: 'popup_closed' });
        }, 500);
      });
    },
  },
});

export default useTwinfieldStore;
